/**
 * Alphabetical sorter
 *
 * @param {String} a
 * @param {String} b
 *
 * @return {Number}
 */
export const alphabetically = (a, b) => a.toLowerCase() > b.toLowerCase() ? 1 : -1;
